import React, { useState } from "react";
import { Link } from "react-router-dom";
import { IMAGE_HEIGHT, IMAGE_HEIGHT_MOBILE, IMAGE_WIDTH, IMAGE_WIDTH_MOBILE } from "../../CatalogueConstants";
import { getWidgetSubtitle, getWidgetTitle, getDefaultDetailBaseURL, generateSlug } from "../../../app/src/Utils/utils";
import style from "./style.module.css";
import MetaData from "../../../app/src/Components/widget_v2/components/MetaData/MetaData";
import GalleryCardComponentV2 from "../../../app/src/Components/common/GalleryCardComponentV2";
import GalleryCardComponent from "../../../app/src/Components/common/GalleryCardComponent";

const ContentCardComponentV2 = ({ content, imageCard, category }) => {
  const [isHover, setIsHover] = useState(false);
  const isMobile = window.innerWidth <= 480;
  const title = getWidgetTitle(content);
  const slug = title ? generateSlug(title) : null;
  const pathname = getDefaultDetailBaseURL() + "/" + content.id + (slug ? "/" + slug : "");

  return (
    <Link
      className="PlaylistItemContainer VideoContainer"
      key={content.id}
      to={{ pathname }}
      onMouseOver={() => setIsHover(true)}
      onMouseOut={() => setIsHover(false)}
    >
      <div className={style.playlistItemContent}>
        <div className={style.playlistItemImage}>
          <GalleryCardComponentV2
            image={imageCard}
            width={isMobile ? IMAGE_WIDTH_MOBILE : IMAGE_WIDTH}
            height={isMobile ? IMAGE_HEIGHT_MOBILE : IMAGE_HEIGHT}
            contentType={content.type?.name}
            tags={content.tags}
            containerIsHover={isHover}
          />
        </div>
        <div className={style.playlistItemFooter}>
          <MetaData category={category} startTimeMs={content?.start * 1000} />
          <div className={style.playlistItemTitle}>{title}</div>
          <div className={style.playlistItemSubtitle}>{getWidgetSubtitle(content)}</div>
        </div>
      </div>
    </Link>
  );
};

export default ContentCardComponentV2;
